import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HighlightDirective } from '../utils/highlight.directive';
import { FormModule } from '@rogers/cdk/form';

@Component({
  standalone: true,
  imports: [CommonModule, HighlightDirective, FormModule],
  selector: 'ucx-address-suggestions',
  templateUrl: './address-autocomplete-suggestions.component.html',
  styleUrls: ['./address-autocomplete-suggestions.component.scss'],
})
export class AddressAutocompleteSuggestionsComponent {
  @Output() optionSelected: EventEmitter<any> = new EventEmitter<any>();
  filteredOptions: any = [];
  _addressInput$;

  get addressInput$() {
    return this._addressInput$;
  }

  @Input() set addressInput$(value) {
    this._addressInput$ = value;
    this.filteredOptions = [];
    if (!value.length) {
      this.filteredOptions.push({
        noAddressFound: true,
        text: 'No address found',
      });
    } else {
      value.slice(0, 4).map((option) => {
        this.filteredOptions.push({ text: option.Text });
      });
    }
  }

  optionClicked(option: string) {
    this.filteredOptions = [];
    this.optionSelected.emit(option);
  }
}
